import React, { useEffect } from 'react';
import Layout from '../components/layout/layout';
import AboutHero from '../components/about_us/hero';
import OurStory from '../components/about_us/our_story';
import WhatWeDo from '../components/about_us/what_we_do';
import Industries from '../components/about_us/industries';
import FAQ from '../components/about_us/faq';
import Connect from '../components/about_us/connect';

export default function AboutUs({ initialData }) {
  useEffect(() => {
    // Get title from initialData if available, otherwise use fallback
    const pageTitle = initialData?.meta?.title || 'WymBee - About The Company';
    document.title = pageTitle;
  }, [initialData]);

  return (
    <Layout initialData={initialData}>
      <AboutHero />
      <OurStory />
      <WhatWeDo />
      <Industries />
      <FAQ />
      <Connect />
    </Layout>
  );
}